<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
input.mx-input {
  height: 40px !important;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        ข้อมูลธุรกิจ
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        elevation="0"
        large
        dark
        class="mr-4 px-10"
        @click="save()"
      >
        <div><v-icon left>mdi-plus</v-icon>บันทึกข้อมูล</div>
      </v-btn>
    </v-layout>
    <v-divider class="mt-2 mb-8"></v-divider>
    <div class="d-flex flex-column">
      <div class="d-flex justify-start">
        <div style="margin-left: 50px; width: 200px">
          <div class="mt-3">
            <h4>ประเภทธุรกิจ :</h4>
          </div>
          <div class="mt-9">
            <h4>ชื่อธุรกิจ :</h4>
          </div>
          <div class="mt-9" style="margin-bottom: 75px !important">
            <h4>ที่อยู่ :</h4>
          </div>
          <div>
            <h4>อีเมล์(ผู้ใช้ระบบ) :</h4>
          </div>
          <div class="mt-11">
            <h4>เลขประจำตัวผู้เสียภาษี :</h4>
          </div>
          <div class="mt-9 mb-10">
            <h4>สำนักงาน/สาขา :</h4>
          </div>
        </div>
        <div style="width: 300px">
          <div>
            <v-select
              solo
              :items="['บริษัท', 'ห้างหุ้นส่วนจำกัด', 'บุคคลธรรมดา']"
              label="ประเภทธุรกิจ"
              v-model="c_type"
            ></v-select>
          </div>
          <div class="mt-n5">
            <v-text-field
              solo
              label="ชื่อธุรกิจ"
              v-model="c_name"
            ></v-text-field>
          </div>
          <div class="mt-n5">
            <v-textarea
              solo
              label="ที่อยู่"
              rows="3"
              no-resize
              v-model="c_address"
            ></v-textarea>
          </div>
          <div class="mt-n5">
            <v-text-field solo label="อีเมล์" v-model="c_email"></v-text-field>
          </div>
          <div class="mt-n5">
            <v-text-field
              solo
              label="เลขประจำตัวผู้เสียภาษี"
              v-model="c_taxid"
            ></v-text-field>
          </div>
          <div class="mt-n5">
            <v-radio-group row class="mb-n5" v-model="c_branch">
              <v-radio
                class="pr-6"
                label="สำนักงานใหญ่"
                hide-details
                value="สำนักงานใหญ่"
              ></v-radio>
              <v-radio
                class="pr-6"
                label="สาขา"
                hide-details
                value="สาขา"
              ></v-radio>
            </v-radio-group>
          </div>
        </div>
        <div style="margin-left: 50px; width: 200px">
          <div class="mt-3">
            <h4>เบอร์สำนักงาน :</h4>
          </div>
          <div class="mt-9">
            <h4>เบอร์มือถือ :</h4>
          </div>
          <div class="mt-9">
            <h4>เบอร์โทรสาร :</h4>
          </div>
          <div class="mt-9">
            <h4>เว็บไซต์ :</h4>
          </div>
        </div>
        <div style="width: 300px">
          <div>
            <v-text-field
              solo
              label="เบอร์สำนักงาน"
              v-model="c_tel"
            ></v-text-field>
          </div>
          <div class="mt-n5">
            <v-text-field
              solo
              label="เบอร์มือถือ"
              v-model="c_mobile"
            ></v-text-field>
          </div>
          <div class="mt-n5">
            <v-text-field
              solo
              label="เบอร์โทรสาร"
              v-model="c_fax"
            ></v-text-field>
          </div>
          <div class="mt-n5">
            <v-text-field
              solo
              label="เว็บไซต์"
              v-model="c_website"
            ></v-text-field>
          </div>
        </div>
      </div>

      <v-divider class="my-2"></v-divider>
      <h3 style="margin-left: 25px">ลายเซ็นอิเล็กทรอนิกส์</h3>
      <div class="d-flex justify-start">
        <div style="margin-left: 50px; width: 225px">
          <div>
            <h4>แนบไฟล์ลายเซ็น:</h4>
          </div>
        </div>
        <div style="width: 300px">
          <div v-if="!haveFile">
            <v-file-input
              :rules="rules"
              accept="image/jpg"
              prepend-icon="mdi-camera"
              label="รูปลายเซ็น.jpg"
              solo
              @change="onSelect"
              class="mt-2"
            ></v-file-input>
            <p>*ขนาดภาพที่แนะนำ 400*140 px และขนาดไม่เกิน 3MB</p>
          </div>
          <div v-else>
            <v-card>
              <v-img :src="imgUrl" height="125" class="white"></v-img>
              <v-layout style="justify-content: flex-end">
                <v-btn @click="changeImg()" text>
                  {{ fileName }}<v-icon>mdi-close</v-icon></v-btn
                >
              </v-layout>
            </v-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from "moment";
import { resolve } from 'path';
export default {
  data: () => ({
    file: "",
    imgUrl: "",
    fileName: "",
    haveFile: false,
    rules: [
      (value) =>
        !value ||
        value.size < 2000000 ||
        "Avatar size should be less than 2 MB!",
    ],
  }),
  created() {
    const user_data = JSON.parse(localStorage.getItem("user"))
    this.getProfile(user_data)
    this.fileName = this.GET_PROFILE.SIGNATURE
    this.getSignature()

  },
  computed: {
    ...mapGetters({
      GET_PROFILE: 'Profile/GET_COMP_PROFILE',
    }),
    c_type: {
      get() { return this.GET_PROFILE.TYPE },
      set(value) { this.C_SET({ key: "TYPE", value: value }) }
    },
    c_name: {
      get() { return this.GET_PROFILE.NAME },
      set(value) { this.C_SET({ key: "NAME", value: value }) }
    },
    c_address: {
      get() { return this.GET_PROFILE.ADDRESS },
      set(value) { this.C_SET({ key: "ADDRESS", value: value }) }
    },
    c_taxid: {
      get() { return this.GET_PROFILE.TAX_ID },
      set(value) { this.C_SET({ key: "TAX_ID", value: value }) }
    },
    c_email: {
      get() { return this.GET_PROFILE.EMAIL },
      set(value) { this.C_SET({ key: "EMAIL", value: value }) }
    },
    c_branch: {
      get() { return this.GET_PROFILE.BRANCH },
      set(value) { this.C_SET({ key: "BRANCH", value: value }) }
    },
    c_tel: {
      get() { return this.GET_PROFILE.TEL },
      set(value) { this.C_SET({ key: "TEL", value: value }) }
    },
    c_mobile: {
      get() { return this.GET_PROFILE.MOBILE_TEL },
      set(value) { this.C_SET({ key: "MOBILE_TEL", value: value }) }
    },
    c_fax: {
      get() { return this.GET_PROFILE.FAX },
      set(value) { this.C_SET({ key: "FAX", value: value }) }
    },
    c_website: {
      get() { return this.GET_PROFILE.WEBSITE },
      set(value) { this.C_SET({ key: "WEBSITE", value: value }) }
    }
  },
  methods: {
    ...mapMutations({
      C_SET_ALL: "Profile/SET_ALL_ELEMENT",
      C_SET: "Profile/SET_ELEMENT",
      LOADER: "Drawer/SET_LOADER"
    }),
    onSelect(file) {
      this.file = file;

    },
    changeImg() {
      this.haveFile = false
    },
    save() {
      let fdata = this.file
      if (fdata) {
        this.C_SET({ key: "SIGNATURE", value: fdata.name })
      }
      this.$token_api
        .post("/update-company-profile", this.GET_PROFILE)
        .then((res) => {
          if (!this.haveFile) {
            this.savefile()
          } else {
            this.$swal(
              "สำเร็จ",
              "แก้ไขข้อมูลเรียบร้อย",
              "success"
            );
          }
        })
        .catch((e) => {
          this.$swal(
            "เกิดข้อผิดพลาดในการอัพโหลด",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
        });
    },
    getProfile(data) {
      this.$token_api
        .post("/select-company-profile", { ID: data.COMP_ID })
        .then((res) => {
          const result = res.data.data
          if (result.length > 0) {
            this.C_SET_ALL(result[0])

          }
        })
        .catch((e) => {
          this.$swal(
            "เกิดข้อผิดพลาดในการอัพโหลด",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
        });
    },
    getSignature() {

      this.$download_api.get(`/download-signature`).then((response) => {
        console.log(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        this.haveFile = true
        this.imgUrl = url
      }).catch((e) => {
        this.haveFile = false
      });


    },
    savefile() {
      const formData = new FormData();
      formData.append("files", this.file);

      this.$file_api
        .post("/upload-signature-img", formData)
        .then((res) => {
          if (res.data.data == 'Upload success')

            this.$swal(
              "สำเร็จ",
              "แก้ไขข้อมูลเรียบร้อย",
              "success"
            );
          this.getSignature()

        }).catch((e) => {
          this.$swal(
            "เกิดข้อผิดพลาดในการอัพโหลด",
            "กรุณาลองใหม่อีกครั้ง",
            "error"
          );
        });
    },
  },
};
</script>